/**
 * Dark Mode Glassmorphism スタイル定義
 * ライト/ダークモード対応のグラスモーフィズム
 */

import type { MantineColorScheme } from '@mantine/core';
import { CSSProperties } from 'react';

export const getGlassStyle = (colorScheme: MantineColorScheme): CSSProperties => {
  if (colorScheme === 'dark') {
    return {
      background: 'rgba(30, 30, 30, 0.7)',
      backdropFilter: 'blur(20px)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
    };
  }

  return {
    background: 'rgba(255, 255, 255, 0.5)',
    backdropFilter: 'blur(16px)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
  };
};

export const getGradientGlowStyle = (
  color: string,
  colorScheme: MantineColorScheme
): CSSProperties => {
  const intensity = colorScheme === 'dark' ? 0.3 : 0.15;
  const glowIntensity = colorScheme === 'dark' ? 0.4 : 0.2;

  const colorRGB = getColorRGB(color);

  return {
    background: `linear-gradient(135deg, rgba(${colorRGB}, ${intensity}) 0%, ${
      colorScheme === 'dark' ? 'rgba(30, 30, 30, 0.7)' : 'rgba(255, 255, 255, 0.5)'
    } 100%)`,
    boxShadow: `0 8px 32px rgba(0, 0, 0, ${colorScheme === 'dark' ? 0.6 : 0.1}), 0 0 40px rgba(${colorRGB}, ${glowIntensity})`,
  };
};

const getColorRGB = (color: string): string => {
  const colorMap: Record<string, string> = {
    blue: '59, 130, 246',
    teal: '20, 184, 166',
    violet: '139, 92, 246',
    cyan: '34, 211, 238',
    green: '34, 197, 94',
    red: '239, 68, 68',
  };
  return colorMap[color] || '100, 100, 100';
};
